// src/utils/authUtils.ts

import { NavigateFunction } from "react-router-dom";
import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";

type AppDispatch = ThunkDispatch<any, unknown, AnyAction>;

let navigateRef: NavigateFunction | null = null;
let dispatchRef: AppDispatch | null = null;
let logoutActionRef: (() => AnyAction) | null = null;

let isRedirecting = false; // 🔥 evita múltiples redirecciones

export const setAuthUtils = (
    navigate: NavigateFunction,
    dispatch: AppDispatch,
    logoutAction: () => AnyAction
) => {
    navigateRef = navigate;
    dispatchRef = dispatch;
    logoutActionRef = logoutAction;
};

export const handleAuthError = () => {
    if (isRedirecting) return; // ya se está redirigiendo
    isRedirecting = true;

    console.warn("Sesión inválida o expirada. Cerrando sesión...");

    // 🔐 1. Limpiar almacenamiento
    localStorage.removeItem("authUser");
    localStorage.removeItem("user");

    // 🧠 2. Limpiar estado Redux
    if (dispatchRef && logoutActionRef) {
        dispatchRef(logoutActionRef());
    }

    // 🚀 3. Redirigir a login
    if (navigateRef) {
        navigateRef("/login", { replace: true });
    } else {
        window.location.href = "/login";
    }
};
